exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#main-page-wrapper.padding-0 {\r\n  padding: 0 !important;\r\n  margin: 0 !important; }\r\n#main-page-wrapper #main-page-wrapper-sub1 {\r\n  padding: 0 !important; }\r\n\r\n.hidden {\r\n  display: none; }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main